module.exports = __webpack_public_path__ + "static/depression-therapy-d5ff53f6398875e4fe268e57e38c4862.jpg";